import router from 'next/router';
import fetchNext from '@features/api/fetchNext';
import getPublicEnv from '@utils/getPublicEnv';

class NextSurveyApi {
  private endpoints = {
    submitQuoteRequest: () => `quote-request`,
    submitDesignStor: () => `design_consultation_stor`,
    submitDesignConsultation: () => `design_consultation`,
    submitReturnRequest: () => `return_request`,
  };

  private static getLocale() {
    const isServerSide = typeof window === 'undefined';
    if (isServerSide) return process.env.DEFAULT_LOCALE;

    const { locale } = router;
    return locale || getPublicEnv('NEXT_PUBLIC_DEFAULT_LOCALE');
  }

  public async submitQuoteRequest(data: {
    fullName: string;
    postalCode: string;
    email: string;
    phoneNumber: string;
    comment: string;
    productName: string;
    productColor: string;
    productImage: string;
    productErp?: string;
  }) {
    const method = 'POST';

    const { json } = await fetchNext(
      this.endpoints.submitQuoteRequest(),
      {
        method,
        body: JSON.stringify({
          fullName: data.fullName,
          postalCode: data.postalCode,
          email: data.email,
          phoneNumber: data.phoneNumber,
          comment: data.comment,
          productName: data.productName,
          productColor: data.productColor,
          productImage: data.productImage,
          ...(data.productErp && { productErp: data.productErp }),
        }),
      },
      NextSurveyApi.getLocale(),
    );

    return json;
  }

  public async submitDesignStor(data: { fullName: string; email: string; phoneNumber: string; comment: string }) {
    const method = 'POST';

    const { json } = await fetchNext(
      this.endpoints.submitDesignStor(),
      {
        method,
        body: JSON.stringify({
          fullName: data.fullName,
          email: data.email,
          phoneNumber: data.phoneNumber,
          comment: data.comment,
        }),
      },
      NextSurveyApi.getLocale(),
    );

    return json;
  }

  public async submitDesignConsultation(data: {
    fullName: string;
    email: string;
    phoneNumber: string;
    postalCode: string;
    comment: string;
  }) {
    const method = 'POST';

    const { json } = await fetchNext(
      this.endpoints.submitDesignConsultation(),
      {
        method,
        body: JSON.stringify({
          fullName: data.fullName,
          email: data.email,
          phoneNumber: data.phoneNumber,
          postalCode: data.postalCode,
          comment: data.comment,
        }),
      },
      NextSurveyApi.getLocale(),
    );

    return json;
  }

  public async submitReturnRequest(data: {
    customerId: string;
    orderId: string;
    languageCode: string;
    returnReason?: string;
    comment?: string;
    product: Array<{
      name: string;
      color?: string;
      image?: string;
      number: string;
      quantity: number;
    }>;
  }) {
    const method = 'POST';

    const { json } = await fetchNext(
      this.endpoints.submitReturnRequest(),
      {
        method,
        body: JSON.stringify({
          customerId: data.customerId,
          orderId: data.orderId,
          languageCode: data.languageCode,
          ...(data.returnReason && { returnReason: data.returnReason }),
          ...(data.comment && { comment: data.comment }),
          product: data.product,
        }),
      },
      NextSurveyApi.getLocale(),
    );

    return json;
  }
}

export default new NextSurveyApi();
